export enum CostbookRowType {
    unknown = 0,
    section = 1,
    equipmentCost = 3,
    materialCost = 5,
    aggregateCost = 6,
    purchaseCost = 7,
    text = 8,
    customCost = 9,
    aggregateCostMLET = 10,
}


// WEBPACK FOOTER //
// ./ClientApp/services/state/costbookRowType.ts